module.exports = __webpack_public_path__ + "img/paint-04.e9b9be22.png";